<div class="my-container">
  <div *ngIf="loaderThemeSelector == 1">
    <ngx-loading [show]="loading">
    </ngx-loading>
  </div>
     
  <div class="loader-overlay" *ngIf="loaderThemeSelector == 2 && loading">
    <p-progressSpinner
      aria-label="loading"
      strokeWidth="5">
    </p-progressSpinner>
  </div>

       <span class="text" *ngIf="loadingmessage!='' && loading">{{loadingmessage}}</span> 
</div>